module.exports = __webpack_public_path__ + "media/src/images/favicon/safari-pinned-tab-8435286f5c9b9faaba4c1b2ec2032ec8.svg";